// @ts-ignore
import { OptionChangedEvent } from 'devextreme/ui/data_grid';

export const sortHelper = (
  e: OptionChangedEvent,
  isDescPrevious: boolean,
  previousSortBy?: string | null,
): { dataField: any; isDesc: boolean } | undefined => {
  if (e.fullName.includes('columns') && e.fullName.includes('sortOrder')) {
    const columnIndex = parseInt(e.fullName.match(/\d+/)![0], 10);

    const changedColumn = e.component.columnOption(columnIndex);

    const dataField = changedColumn.dataField;

    const isSameColumn = previousSortBy === dataField;

    return {
      dataField,
      isDesc: isSameColumn ? !isDescPrevious : false,
    };
  }
};

type GridHeaderClickEvent = {
  rowType?: string;
  column?: {
    dataField?: unknown;
    allowSorting?: boolean;
  };
};

export const headerSortClick = (
  event: GridHeaderClickEvent,
  changeSorting: (sortBy: string) => void,
) => {
  if (event.rowType !== 'header') {
    return;
  }

  const sortBy = event.column?.dataField;
  const isSortingAllowed = event.column?.allowSorting;

  if (!isSortingAllowed || typeof sortBy !== 'string' || !sortBy) {
    return;
  }

  changeSorting(sortBy);
};
